import { createFileRoute } from '@tanstack/react-router';

interface EditSearch {
  retriggerMode: 'reset_all' | 'continue';
  startStep?: number;
}

export const Route = createFileRoute('/w/signing-requests/$requestId_/edit')({
  staticData: {
    hideShell: true,
    breadcrumb: 'Edit Signing Request',
    breadcrumbKey: 'K_BREADCRUMB_EDIT_SIGNING_REQUEST',
  },
  validateSearch: (search: Record<string, unknown>): EditSearch => ({
    retriggerMode: (search.retriggerMode as 'reset_all' | 'continue') ?? 'reset_all',
    startStep: search.startStep != null ? Number(search.startStep) : undefined,
  }),
});
